import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { AssetData } from '../models/assetData.model';
import { ActivityLog } from '../models/activityLog.model';
import { TopPerforming } from '../models/topPerforming.model';
import { MapFilter } from '../models/mapFilter.model';
import { AssetsCounts } from '../models/assetsCounts';
import { Coordinates } from '../models/coordinates.model';

@Injectable({
    providedIn: 'root'
  })
  export class DashboardService {
  
    private pathApi = this.config.setting['pathApi'] + "dashboard/";
    private headers = new HttpHeaders({'Content-Type': 'application/json'});
    
    constructor(private http: HttpClient, private config: AppConfig) {
  
    }
    
    // getAnalyticsOveriview(){
    //   return this.http.get<Map<number,AssetData>>(`${this.pathApi}getAnalyticsOverview`,{headers: this.headers, observe: 'response'});
    // }


    getDashboardMeterValidation(utilityId: number | null = null): Observable<any> {
      return this.http.get(`${this.pathApi}getDashboardValidationMeters?utilityId=${utilityId}`, { headers: this.headers, observe: 'response' });
    }
    
    getAnalyticsOveriviewBuilding(obj : any){
      return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewBuilding`,obj,{headers: this.headers, observe: 'response'});
    }
    getAnalyticsOveriviewCustomer(obj : any){
      return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewCustomer`,obj,{headers: this.headers, observe: 'response'});
    }
    getAnalyticsOveriviewDt(obj : any){
      return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewDt`,obj,{headers: this.headers, observe: 'response'});
    }
    getAnalyticsOveriviewPole(obj : any){
      return this.http.post<any>(`${this.pathApi}getAnalyticsOverviewPole`,obj,{headers: this.headers, observe: 'response'});
    }

    getAssetsCounts(areaIds : number[]) {
      return this.http.post<any>(`${this.pathApi}getAssetsCounts`,areaIds,{headers: this.headers, observe: 'response'});
    }

    getGraphData(request : any) {
      let param = JSON.stringify(request);
      return this.http.post<any>(`${this.pathApi}getGraphData`,param,{headers: this.headers, observe: 'response'});
    }

    getOperationsAnalytics(obj : any) {
      return this.http.post<any>(`${this.pathApi}getOperationsAnalytics`, obj, {headers: this.headers, observe: 'response'});
    }

    getMapData(obj: any) {
      let param = JSON.stringify(obj);
      return this.http.post<any>(`${this.pathApi}getMapData`,param,{headers: this.headers, observe: 'response'});
    }

    getDefaultCoordinates(obj: any) {
      return this.http.post<Coordinates>(`${this.pathApi}getDefaultCoordinates`,obj,{headers: this.headers, observe: 'response'});
    }
    getNetworkAssetOptions(option: number) {
      return this.http.get<any>(`${this.pathApi}getNetworkAssetOptions/${option}`,{headers: this.headers, observe: 'response'});
    }
}